module.exports = __webpack_public_path__ + "static/headshot-b07c6e33c5c966da58f564770263f891.jpg";